import type { DecisionMakerContainerStatus, DecisionMakerSectionTracking } from '../../../../types';

type Input = {
	status: DecisionMakerContainerStatus;
	step: string;
	/** The decision makers the cards show. */
	dmCount: number;
	/** How many DMI found, kept or not. */
	foundCount: number;
	/** Whether DMI's result is on the draft: it stays unset when DMI failed or didn't finish. */
	dmiSettled: boolean;
};

/** What sap_dm_section_view and sap_dm_section_impression send for what the section shows; nothing while hidden. */
export function getSectionTracking({
	status,
	step,
	dmCount,
	foundCount,
	dmiSettled,
}: Input): DecisionMakerSectionTracking | undefined {
	if (status === 'hidden') return undefined;
	if (status === 'loading') return { step, dm_section_state: 'loading' };
	if (status === 'done') return { step, dm_section_state: 'done', dm_count: dmCount };
	if (foundCount > 0) return { step, dm_section_state: 'empty', dm_empty_reason: 'removed_all' };
	return { step, dm_section_state: 'empty', dm_empty_reason: dmiSettled ? 'none_found' : 'failed' };
}
